'use client'

import styled from "styled-components";
import Description from "@/components/UI/Description/Description";
import Form from "@/components/UI/Form/Form/Form";
import {getColor, getMedias} from "@/pipes/theme.pipe";
import PasswordInput from "@/components/UI/Form/Inputs/PasswordInput/PasswordInput";
import EmailInput from "@/components/UI/Form/Inputs/EmailInput/EmailInput";
import Button from "@/components/UI/Button/Button";
import Title from "@/components/UI/Title/Title";
import Submit from "@/components/UI/Form/Submit/Submit";

export const SignInWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    flex: 1;
    gap: 14px;
`

export const SignInTitle = styled(Title).attrs({
    size: 'md'
})`
    font-size: clamp(24px, 4vw, 36px);
`

export const SignInForm = styled(Form)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: clamp(15px, 2vw, 30px);
    width: 100%;
`

export const SignInEmailInput = styled(EmailInput)``

export const SignInPasswordInput = styled(PasswordInput)``

export const ForgotPasswordButton = styled(Button).attrs({
    variant: 'link',
    href: '',
    color: 'secondaryDark'
})`
    margin-block: clamp(20px, 4vw, 60px);
    text-decoration: underline;
    color: ${getColor('primary', '500')} !important;
    
    @media (${getMedias('TABLET')}) {
        padding: 0;
        margin: 0 0 20px;
    }
`

export const LoginButton = styled(Submit).attrs({
    size: 'lg',
    color: 'secondaryDark'
})`
    max-width: 113px;
    font-size: 14px;
`

export const Text = styled(Description).attrs({
    size: 'sm'
})`
    a {
        padding: 0;
    }
`

export const SignUpButton = styled(Button).attrs({
    variant: 'link',
    href: 'signup'
})`
    text-decoration: underline;
    font-weight: 600;
    color: ${getColor('primary', '500')} !important;
`
